import other from "../../common/images/other.png";
import { Link } from "react-router-dom";
import iconOne from "../../common/images/all-s-1.png";
import iconTwo from "../../common/images/all-s-2.png";
import iconThree from "../../common/images/all-s-3.png";
import iconFour from "../../common/images/all-s-4.png";
import iconFive from "../../common/images/all-s-5.png";
import iconSix from "../../common/images/all-s-6.png";

const services = [
  {
    title: "UI/UX ",
    titleTwo: "Design",
    description: "User-friendly and engaging designs",
    image: iconOne,
    link: "/uiux-designer",
  },
  {
    title: "Web",
    titleTwo: " Development",
    description: "Building responsive and scalable websites",
    image: iconTwo,
    link: "/website-development",
  },
  {
    title: "Mobile App",
    titleTwo: " Development",
    description: "Android, iOS, and hybrid app development.",
    image: iconThree,
    link: "/android-development",
  },
  {
    title: "Custom Software",
    titleTwo: " Development",
    description: "Tailored software solutions for business needs.",
    image: iconFour,
    link: "/custom-software-development",
  },
  {
    title: "POS",
    titleTwo: " Solutions",
    description: "Streamlined point-of-sale systems.",
    image: iconFive,
    link: "/point-of-sale-development",
  },
  {
    title: "CRM",
    titleTwo: " Development",
    description: "Customer relationship management",
    image: iconSix,
    link: "/crm-development",
  },
];

const ServicesSection = () => {
  return (
    <div className="bg-gradient-to-b from-[#F2FBFE] to-white">
      <section className="max-w-[1280px] mx-auto md:px-10 px-5 md:py-10 py-7 text-center">
        <h2 className="text-3xl md:text-5xl small:text-4xl font-bold text-center text-black">
          Our Services{" "}
        </h2>
        <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
          <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
        </div>
        <p className="text-center text-black mt-2">
          Transforming ideas into innovative digital solutions with expertise in
          technology and development{" "}
        </p>
        <div className="mt-8 grid grid-cols-1 small:grid-cols-2 md:gap-0 gap-3 md:grid-cols-3 relative">
          {services.map((service, index) => (
            <div
              key={index}
              className={`text-start  p-6 md:border-dashed md:border-gray-200 md:shadow-none shadow-lg md:rounded-none rounded-md relative
              ${index < 3 ? "md:border-b-[2px]" : ""} 
              ${index % 3 !== 2 ? "md:border-r-[2px]" : ""}`}
            >
              <div className="flex md:flex-row flex-col-reverse md:justify-between justify-center">
                <div className=" text-black font-medium md:block small:text-3xl text-2xl">
                  <h3>{service.title}</h3>
                  <h3 className="">{service.titleTwo}</h3>
                </div>

                <img
                  src={service.image}
                  alt={service.title}
                  className="w-[60px] h-[60px] object-contain mb-2 md:mb-0  "
                />
              </div>
              <p className="text-gray-600 my-2">{service.description}</p>
              <Link to={service.link} className="self-end flex">
                <img
                  src={other}
                  alt="icon"
                  className="self-end text-gray-500 mt-auto absolute md:bottom-2 bottom-0 md:right-5 right-0 w-[40px] cursor-pointer"
                />
              </Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ServicesSection;
